// Generated by ts-to-zod
import { z } from 'zod';

export const annotationWorkflowPayloadSchema = z.object({
  noteContent: z.string().optional(),
});
